module.exports = __webpack_public_path__ + "static/media/level3_q1_wrong.a1775a34.png";